import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react'
import styles from '../styles/receiveCashGift.module.scss'
import { useTranslation } from 'react-i18next'
import { useCheckBonusEligibility, useVipCfgList, useVipPromotionList } from '../hooks/useVip'
import { useUserInfo } from '@/api/request'
import { useModal } from '@/modals/modalContext'
import ErrorMessageDialog from '@/antComponent/errorMessageDialog'
import SelectPlus from '@/wmCompoments/select'
import SpriteContainer from '@/wmCompoments/spriteContainer'
import Icon from '@/wmCompoments/Icon'


interface GlobalVipUpRewardDataType {
  venueItem: any; 
  verificationData: any;
}
export let globalVipUpRewardData: GlobalVipUpRewardDataType = {
  venueItem: null,
  verificationData: null,
};

const ReceiveCashGift = ({userInfo, gradeData, grade, configData}) => {
  const { t } = useTranslation('vip')
  const { openModal } = useModal()

  const { memberGradeConfigList: vipList, memberInfoChangeList: vipInfo } = gradeData || {}
  
  //  领取vip礼金
    const containerRef = useRef<HTMLDivElement | null>(null);
    const [container, setContainer] = useState<HTMLElement | null>(null);
    // 组件挂载后再设置 portal 容器
    useEffect(() => {
        if (containerRef.current) {
            setContainer(containerRef.current);
        }
    }, []);

    useEffect(() => {
      if (!configData) return
      if (configData?.rules?.[0]?.gameVenueVos?.length) {
        setVenueItem(configData?.rules?.[0]?.gameVenueVos[0])
      }
    }, [configData])

    const levelMismatch = useMemo(() => {
      return vipInfo?.vipGrade == grade
    }, [vipInfo, grade])
    // 下拉框数据
    const options = useMemo(() => {
      if (!configData) return []
      const rules = configData?.rules?.[0]
      const { gameVenueVos = [] } = rules || {}
      return gameVenueVos.map((v) => {
        return {
          ...v,
          label: v.venueZhName,
          value: v.venueId
        }
      })
    }, [configData])

    const [selectedValue, setSelectedValue] = useState<any>();
    const [selectedItem, setSelectedItem] = useState<any>(null);
    // 默认第一项
    useEffect(() => {
      if (options.length > 0 && !selectedValue) {
        setSelectedValue(options[0].value);
        setSelectedItem(options[0]);
      }
    }, [options, selectedValue]);
    const { isMutating, trigger } = useCheckBonusEligibility()
    const [venueItem, setVenueItem] = useState<any>()
    // const verificationDataRef = useRef<any>(null)
    const [verificationData, setVerificationData] = useState<any>(null); 
    const handleConfirm = async () => {
      try {
        const data = await trigger({
          venueId: selectedItem?.venueId,
          advanceId: configData?.rules?.[0]?.advanceId,
          vipGrade: userInfo?.vipGrade
        });
        setVenueItem(selectedItem);
        setVerificationData(data)
        // 保存到全局共享
        globalVipUpRewardData = {
          venueItem: selectedItem,
          verificationData: data,
        };
        // verificationDataRef.current = data;
        openModal('vipUpReward')
      } catch (error: any) {
        ErrorMessageDialog(error?.message || JSON.stringify(error));
      }
    };

  return (
    <div className={styles.ReceiveCashGift}>
      <div ref={containerRef} className={styles.container}>
        <SelectPlus
          options={options}
          value={selectedValue}
          onChange={(v, o) => {
            setSelectedValue(v);
            setSelectedItem(o);
          }}
          optionRender={(opt, selected) => (
            <div className={styles.optionRender}>
              <span>{opt.label}</span>
              {selected && <SpriteContainer name="icon_checked" />}
            </div>
          )}
          labelRender={(opt) => {
            return (
              <div className={styles.labelRender}
                onClick={(e) => {
                  if (isMutating) {
                    e.stopPropagation(); 
                    ErrorMessageDialog(t('receiveCashGift.tooFrequent'));
                    return;
                  }
                  if (!levelMismatch) {
                    e.stopPropagation(); 
                    ErrorMessageDialog((t('receiveCashGift.levelMismatch')));
                    return;
                  }
                }}
              >
                <span>{opt?.label}</span>
                <Icon name={'icon-general-arrow-line-right'} className={styles.icon} />
              </div>
            )
          }}
          className={styles.select}
        />
      </div>
      
      <button 
        onClick={()=>{
          handleConfirm()
          // openModal('vipUpReward')
        }}
        disabled={!levelMismatch || !venueItem?.value?.length}
      >
        {t('vipCard.claimReward')}
      </button>
    </div>
  )
}

export default ReceiveCashGift

